export const SocialProofResources = {
    1: {
        proof: "800+",
        text: "sklepów partnerskich",
    },
    2: {
        proof: "do 60%",
        text: "cashbacku",
    },
    3: {
        proof: "1 mln+",
        text: "osób już korzysta z goodie",
    },
    4: {
        proof: "110 mln zł",
        text: "naliczonego cashbacku",
    },
};
